import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';
import { StatusMessage, StatusMessageModel, StatusMessageType } from '../../Widgets/StatusMessage'

export interface OfferDashboardOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlCount: string;
}

var FILTER_DELIM = '-delim-';
const batchSize = 100;

class FreeRoundBrowseRequest {
    public OfferId: string;
    public CampaignId: string;
    public CustomerId: string;
    public RemoteId: string;
    public CustomerOperationId: string;
    public PlayerRemoteId: string;
    public PlayerName: string;
    public PlayerId: string;
    public CurrencyId: string;
    public CampaignName: string;
    public CampaignRemoteId: string;
    public WinPayMethods: string;
    public WinFrom: string;
    public WinTo: string;
    public RoundsAssignedFrom: string;
    public RoundsAssignedTo: string;
    public RoundsPlayedFrom: string;
    public RoundsPlayedTo: string;
    public PendingSpinsFrom: string;
    public PendingSpinsTo: string;
    public ValidFrom: number | null;
    public ValidTo: number | null;
    public Result: string;
    public Status: string;
    public Source: string;
    public LastOfferId: number | null;
    public BatchSize: number;
}

export class OfferDashboard extends PageBase<OfferDashboardOptions>  {
    private _runButton: JQuery;
    private _loadMoreButton: JQuery;
    private _resetFilterButton: JQuery;
    private _currentRequest: FreeRoundBrowseRequest;

    private _filterPlayerRemoteId: JQuery;
    private _filterRemoteId: JQuery;
    private _filterResult: MultiSelectApi;
    private _filterStatus: MultiSelectApi;
    private _filterCurrency: MultiSelectApi;
    private _filterCampaignId: JQuery;
    private _filterCustomerId: MultiSelectApi;
    private _filterCampaignName: JQuery;
    private _filterCampaignRemoteId: JQuery;
    private _filterWinPayMethods: MultiSelectApi;
    private _filterWinFrom: JQuery;
    private _filterWinTo: JQuery;
    private _filterRoundsAssignedFrom: JQuery;
    private _filterRoundsAssignedTo: JQuery;
    private _filterRoundsPlayedFrom: JQuery;
    private _filterRoundsPlayedTo: JQuery;
    private _filterPendingSpinsFrom: JQuery;
    private _filterPendingSpinsTo: JQuery;
    private _filterOfferId: JQuery;
    private _filterSource: JQuery;
    private _btnCountResult: JQuery;
    private _totalEntries: JQuery;
    private _checkAll: JQuery;
    private _processing: JQuery;
    private _statusMessage: JQuery;

    constructor(options: OfferDashboardOptions) {
        super(options);

        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
        this.run = this.run.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.toggleSortDirection = this.toggleSortDirection.bind(this);
        this.getCountResult = this.getCountResult.bind(this);
        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
        this.enableRunButton = this.enableRunButton.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this._options = options;
    }

    init(): void {
        this._filterCustomerId = new MultiSelectApi('filterCustomerId');
        this._filterPlayerRemoteId = Utils.getJQueryById('filterPlayerRemoteId');
        this._filterRemoteId = Utils.getJQueryById('filterRemoteId');
        this._filterResult = new MultiSelectApi('filterResult');
        this._filterStatus = new MultiSelectApi('filterStatus');
        this._filterCurrency = new MultiSelectApi('filterCurrency');
        this._filterCampaignId = Utils.getJQueryById('_filterCampaignId');
        this._filterCampaignName = Utils.getJQueryById('filterCampaignName');
        this._filterCampaignRemoteId = Utils.getJQueryById('filterCampaignRemoteId');
        this._filterWinPayMethods = new MultiSelectApi('filterWinPayMethods');
        this._filterWinFrom = Utils.getJQueryById('filterWinFrom');
        this._filterWinTo = Utils.getJQueryById('filterWinTo');
        this._filterRoundsAssignedFrom = Utils.getJQueryById('filterRoundsAssignedFrom');
        this._filterRoundsAssignedTo = Utils.getJQueryById('filterRoundsAssignedTo');
        this._filterRoundsPlayedFrom = Utils.getJQueryById('filterRoundsPlayedFrom');
        this._filterRoundsPlayedTo = Utils.getJQueryById('filterRoundsPlayedTo');
        this._filterPendingSpinsFrom = Utils.getJQueryById('filterPendingSpinsFrom');
        this._filterPendingSpinsTo = Utils.getJQueryById('filterPendingSpinsTo');
        this._filterOfferId = Utils.getJQueryById('filterOfferId');
        this._filterSource = Utils.getJQueryById("filterSource");

        this._runButton = Utils.getJQueryById("btnRunQuery");
        this._runButton.on("click", this.run);
        this._loadMoreButton = Utils.getJQueryById("btnLoadMore");
        this._loadMoreButton.on("click", this.loadMore);
        this._resetFilterButton = Utils.getJQueryById("btnResetFilter");
        this._resetFilterButton.on("click", this.resetFilter);
        this._btnCountResult = Utils.getJQueryById("btnCountResult");
        this._btnCountResult.on("click", this.getCountResult);
        this._totalEntries = Utils.getJQueryById("totalEntries");
        this._checkAll = Utils.getJQueryById("selectAll");
        this._checkAll.on("change", this.checkBoxAll);
        this._processing = Utils.getJQueryById("processing");
        this._statusMessage = Utils.getJQueryById("statusMessageWrapper");
    }

    private run(): void {
        this.disableRunButton();
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        totalEntries.innerText = "##";
        this._currentRequest = this.getBrowseRequest();
        let table = this.getTableBody();
        table.innerHTML = "";
        this.sendRequest(this._currentRequest);
    }

    private loadMore(): void {
        this.sendRequest(this._currentRequest);
    }

    private showLoadMoreButton(): void {
        this._loadMoreButton.removeClass("display-none");
    }

    private hideLoadMoreButton(): void {
        this._loadMoreButton.addClass("display-none");
    }

    private disableRunButton(): void {
        this._runButton.attr("disabled", 1);
    }

    private enableRunButton(): void {
        this._runButton.removeAttr("disabled");
    }

    private resetFilter(): void {
        this._filterCustomerId.selectAll();
        this._filterStatus.selectAll();
        this._filterResult.selectAll();
        this._filterCurrency.selectAll();
        this._filterWinPayMethods.selectAll();

        this._filterPlayerRemoteId.val('');
        this._filterRemoteId.val('');
        this._filterWinFrom.val('');
        this._filterWinTo.val('');
        this._filterCampaignId.val('');
        this._filterCampaignName.val('');
        this._filterCampaignRemoteId.val('');
        this._filterWinFrom.val('');
        this._filterWinTo.val('');
        this._filterRoundsAssignedFrom.val('');
        this._filterRoundsAssignedTo.val('');
        this._filterRoundsPlayedFrom.val('');
        this._filterRoundsPlayedTo.val('');
        this._filterPendingSpinsFrom.val('');
        this._filterPendingSpinsTo.val('');

        this._filterOfferId.val('');
        this._filterSource.val('Live');
    }

    private getCountResult() {
        let request = Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
        let urlCount = this._options.urlCount;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        let processing = this._processing;
        let statusMessage = this._statusMessage
        let displayMessage = this.displayMessage;
        processing.show();
        $.ajax({
            url: urlCount,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                totalEntries.innerText = data;
                processing.hide();
                statusMessage.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                displayMessage(jqXHR);
            }
        });
    }

    private getDetailUrl(detailUrl: string, data: any): string {
        return `${detailUrl}/${data}`;
    }

    private sendRequest(request: FreeRoundBrowseRequest) {
        let urlList = this._options.urlList;
        let detailUrl = this._options.urlDetail;
        let table = this.getTableBody();
        let getDetailUrl = this.getDetailUrl;
        let showLoadMore = this.showLoadMoreButton;
        let hideLoadMore = this.hideLoadMoreButton;
        let enableRunButton = this.enableRunButton;
        let processing = this._processing;
        let statusMessage = this._statusMessage
        let displayMessage = this.displayMessage;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        processing.show();
        $.ajax({
            url: urlList,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                let parsedData = JSON.parse(data);
                let items = parsedData.Items;
                let totalCount = parsedData.FilteredCount;
                if (items.length < batchSize + 1) {
                    hideLoadMore();
                }
                else {
                    request.LastOfferId = items[batchSize].Id;
                    showLoadMore();
                }
                const enabled = ['Completed', 'Declined', 'Canceled'];
                $.each(items, function (index, item) {
                    if (index < batchSize) {
                        let row = table.insertRow(-1);
                        let cell0 = row.insertCell(0);
                        cell0.innerHTML = `<input name='selectedFreeRound' value='${item.GameRoundId}' type='checkbox' onClick="setSelectAllCheckbox()" />`;
                        let cell1 = row.insertCell(1);
                        cell1.innerHTML = `<a target="_blank" rel="noopener noreferrer" href='${getDetailUrl(detailUrl, item.Id)}'><b>Offer ID: </b>${item.Id}</a><br/><b>Remote ID: </b>${item.RemoteId}`;
                        let cell2 = row.insertCell(2);
                        cell2.innerHTML = `<b>Customer: </b>${item.CustomerName}<br/><b>Campaign Remote ID: </b>${item.CampaignRemoteId}`;
                        let cell3 = row.insertCell(3);
                        cell3.innerHTML = `<b>Player ID: </b>${item.PlayerRemoteId ? item.PlayerRemoteId : ""}`;
                        let cell4 = row.insertCell(4);
                        let css = enabled.indexOf(item.Status) > -1 ? "status-enabled" : "status-disabled";
                        cell4.innerHTML = `<b>Result: </b>${item.Result ? item.Result : ""}<br/><b>Status: </b><span class="${css}">${item.Status}</span>`;
                        let cell5 = row.insertCell(5);
                        cell5.innerHTML = `<b>Awarded: </b>${item.RoundsAssigned}<br/><b>Used: </b>${item.RoundsPlayed}<br/><b>Remaining: </b>${item.PendingSpins}`;
                        let cell6 = row.insertCell(6);
                        cell6.innerHTML = `<b>Win amount: </b>${item.TotalWin} ${item.CurrencyCode ? item.CurrencyCode : ""}<br/><b>Currency: </b>${item.CurrencyCode ? item.CurrencyCode : ""}<br/><b>Win pay method: </b>${item.WinPayMethod}`;
                    }
                });
                totalEntries.innerText = totalCount;
                processing.hide();
                enableRunButton();
                statusMessage.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                enableRunButton();
                displayMessage(jqXHR);
            }
        });
    }

    private displayMessage(jqXHR: JQueryXHR): void {
        var statusMessageWrapper = Utils.getJQueryById("statusMessageWrapper");
        let statusMessageData = <StatusMessageModel>{
            code: "500",
            autoClose: false,
            class: "danger",
            message: "Unexpected error",
            type: StatusMessageType.Error
        };
        var statusMessage = new StatusMessage(statusMessageData);
        statusMessageWrapper.html(statusMessage.getHTMLmessage());
        StatusMessageHelper.initValidator();
        StatusMessageHelper.initSatusMessage();
        statusMessageWrapper.show();
    }

    private getTableBody(): HTMLTableSectionElement {
        return document.getElementById("tableFreeRoundCampaign").getElementsByTagName("tbody")[0];
    }

    private toggleSortDirection(e: JQueryEventObject) {
        var value = (<HTMLInputElement>e.currentTarget).value;
        if (value === "ASC") {
            (<HTMLInputElement>e.currentTarget).value = "DESC";
        }
        else {
            (<HTMLInputElement>e.currentTarget).value = "ASC";
        }
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedFreeRound']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._checkAll[0]).checked;
        }
    }

    private setSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedFreeRound']");
        let selectAll = Utils.getJQueryById("selectAll")[0];
        if (Utils.isNullOrUndefined(selectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>selectAll).checked = allCheckboxesChecked;
    }

    private getBrowseRequest(): FreeRoundBrowseRequest {
        let request = new FreeRoundBrowseRequest();
        request.OfferId = this._filterOfferId.val();
        request.CustomerId = this._filterCustomerId.isAllSelected() ? '' : this._filterCustomerId.getSelectionValues(FILTER_DELIM);
        request.PlayerRemoteId = this._filterPlayerRemoteId.val();
        request.RemoteId = this._filterRemoteId.val();
        request.CurrencyId = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
        request.CampaignId = this._filterCampaignId.val();
        request.CampaignName = this._filterCampaignName.val();
        request.CampaignRemoteId = this._filterCampaignRemoteId.val();
        request.WinPayMethods = this._filterWinPayMethods.isAllSelected() ? '' : this._filterWinPayMethods.getSelectionValues(FILTER_DELIM);
        request.WinFrom = this._filterWinFrom.val();
        request.WinTo = this._filterWinTo.val();
        request.RoundsAssignedFrom = this._filterRoundsAssignedFrom.val();
        request.RoundsAssignedTo = this._filterRoundsAssignedTo.val();
        request.RoundsPlayedFrom = this._filterRoundsPlayedFrom.val();
        request.RoundsPlayedTo = this._filterRoundsPlayedTo.val();
        request.PendingSpinsFrom = this._filterPendingSpinsFrom.val();
        request.PendingSpinsTo = this._filterPendingSpinsTo.val();
        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        request.BatchSize = batchSize + 1;
        request.Source = this._filterSource.val();
        return request;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundCampaigns/OfferDashboard.ts
 **/